import React from 'react';
import PropTypes from 'prop-types';

import { enforceParameters } from '../../hocs/enforce-parameters';
import { ConfigParametersStore } from '../../stores/ConfigParametersStore';
import styles from './Plans.css';

const IPropTypes = {
  productId: PropTypes.string.isRequired,
  position: PropTypes.string,
  size: PropTypes.string,
};

const defaultProps = {
  position: 'end',
  size: '85px',
};

const Plans = (props) => {
  if (!ConfigParametersStore.plans) {
    return null;
  }

  const plans = ConfigParametersStore.plans.mapArticle[parseInt(props.productId, 0)];
  const names = ConfigParametersStore.plans.mapName;
  const links = ConfigParametersStore.plans.mapLink;
  const images = ConfigParametersStore.plans.mapImage;
  return plans && plans.length ?
    <div className={styles.plans} style={{ justifyContent: props.position }}>
      {plans.map(plan => (links && links[plan] && !window.location.pathname.includes('products-group/plan-redondo') ?
        <a key={plan.id} href={links[plan]} target="_blank">
          <img
            src={images[plan]}
            alt={names[plan]}
            style={{ width: props.size, height: props.size }}
          />
        </a> :
        <img
          key={plan.id}
          src={images[plan]}
          alt={names[plan]}
          style={{ width: props.size, height: props.size }}
        />))
      }
    </div> : <div style={{ opacity: 0 }}>1</div>;
};

Plans.propTypes = IPropTypes;
Plans.defaultProps = defaultProps;

const WrappedPlans = enforceParameters(Plans);

export { WrappedPlans as Plans };



// WEBPACK FOOTER //
// ./src/common/plans/Plans.jsx